// See menu-header in Figma
// https://www.figma.com/design/NtKUlPYqtoSzzG4BFh55KG/-Redesign--Mem-Design-System?node-id=7336-32721&t=KwbAgWREqjcX2XvC-4

import { StyledPopoverHeader } from "@/mds/components/forms/select/select.style";
import { MDSText, MDSTextColor, MDSTextVariant, MDSTextWeight } from "@/mds/components/text";
import { PropsWithChildren } from "react";

interface Props extends PropsWithChildren {
  label?: string;
}
export const MDSSelectHeader = ({ label, children }: Props) => {
  return (
    <StyledPopoverHeader $position="top">
      {label && (
        <MDSText
          variant={MDSTextVariant.TextXs}
          weight={MDSTextWeight.SemiBold}
          color={MDSTextColor.Secondary}
        >
          {label}
        </MDSText>
      )}
      {children}
    </StyledPopoverHeader>
  );
};
